// cookie.ts

export interface CookieOptions {
  [key: string]: any;
}

export interface CookieModule {
  getCookie(name: string): string | undefined;
  setCookie(name: string, value: string, options?: CookieOptions): void;
  deleteCookie(name: string): void;
}

const Cookie: CookieModule = (() => {
  return {
    getCookie: (name: string): string | undefined => {
      const matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
      );
      return matches && matches[1] ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookie: (name: string, value: string, options: CookieOptions = { path: "/" }): void => {
      let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

      if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
      } else if (typeof options.expires === "number") {
        options.expires = new Date(Date.now() + options.expires * 1000).toUTCString();
      } else if (typeof options.expires === "string") {
        options.expires = new Date(options.expires).toUTCString();
      }

      for (const [optionKey, optionValue] of Object.entries(options)) {
        updatedCookie += "; " + optionKey;
        if (optionValue !== true) {
          updatedCookie += "=" + encodeURIComponent(optionValue);
        }
      }

      document.cookie = updatedCookie;
    },
    deleteCookie: (name: string): void => {
      Cookie.setCookie(name, "", {
        "max-age": -1,
      });
    },
  };
})();

export default Cookie;
